import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { PlumaPlainModal } from '@customerio/pluma-components/css/components';

const SHEET_TOP_GAP = '28px';
const CONTENT_MAX_WIDTH = '880px';
const regionBorder = `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`;
const transitionDuration = PlumaPlainModal.resolvedVars.plainModalAnimationTransitionDuration;

// Layered on top of Pluma's modal overlay, which supplies the backdrop and its fade.
export const overlay = style(
  {
    alignItems: 'flex-end',
  },
  'flex-plan-sheet-overlay',
);

export const sheet = style(
  {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: `calc(100% - ${SHEET_TOP_GAP})`,
    overflow: 'hidden',
    backgroundColor: themeVars.color['surface-content'],
    borderTopLeftRadius: themeVars.radius['10'],
    borderTopRightRadius: themeVars.radius['10'],
    boxShadow: themeVars.depth['surface-3'],
    transform: 'none',
    transition: `transform ${transitionDuration} ${themeVars.motion['easing-entrance-expressive']}`,
    selectors: {
      '&[data-status="initial"], &[data-status="close"]': { transform: 'translateY(100%)' },
      '&[data-status="close"]': {
        transitionTimingFunction: themeVars.motion['easing-exit-expressive'],
      },
    },
    '@media': {
      '(prefers-reduced-motion: reduce)': { transition: 'none' },
    },
  },
  'flex-plan-sheet',
);

export const header = style(
  {
    position: 'relative',
    flexShrink: 0,
    borderBottom: regionBorder,
  },
  'flex-plan-sheet-header',
);

export const closeButton = style(
  {
    position: 'absolute',
    top: themeVars.space['250'],
    right: themeVars.space['300'],
  },
  'flex-plan-sheet-close-button',
);

export const body = style(
  {
    flex: 1,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
  'flex-plan-sheet-body',
);

export const footer = style(
  {
    flexShrink: 0,
    borderTop: regionBorder,
  },
  'flex-plan-sheet-footer',
);

export const column = style(
  {
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    marginInline: 'auto',
    paddingInline: themeVars.space['400'],
    '@media': {
      'screen and (max-width: 700px)': { paddingInline: themeVars.space['200'] },
    },
  },
  'flex-plan-sheet-column',
);
